import React, { useState, useEffect, useMemo, useContext } from "react";
import { useNavigate, useParams } from "react-router";
import * as FileSaver from "file-saver";
import { toast } from "react-toastify";
import swal from "sweetalert";
import SelectOption from "components/common/Select/Select";
import SideBar from "components/common/SideBar/SideBarNew";
import TableHeader from "components/common/Table/TableHeader";
import { LOADER_STATUS, USER_ROLE } from "Constants/constant";
import { LoginContext } from "helpers/LoginContext";
import { roleAccess } from "helpers/RolesPermission";
import CheckBox from "components/common/checkBox/checkbox";
import NdisClaimNewTableItem from "./NdisClaimNewTableItem";
import CircularLoader from "components/common/CircularLoader/CircularLoader";
import NdisClaimNewModal from "./NdisClaimNewModal";
import SelectBox from "components/common/DropDownWithIocns/DropDown";
import Breadcrumb from "components/common/Breadcrumb";
import {
  COS_BREADCRUMB,
  COS_BREADCRUMB_PAGES,
} from "Constants/BreadcrumbConstant";
import Header from "components/common/Header/Header";
import api from "store/services/cos.services";
import useCareLabels from "hooks/useCareLabels";

const NdisClaimReview = (props) => {
  const {
    changeStatusSuccess,
    emptyTableData,
    getCaseNotesReviewRequest,
    changeStatus,
    statusList,
    selectedClientList,
    caseNoteReview,
    caseNoteReviewLoading,
    changeNDISCaseNotesStatusLoading,
    caseNotesListForClaim,
    caseNotesListForClaimLoader,
    ndisClaimMode,
    getNdisClaimMode,
  } = props;

  const { uuid } = useParams();
  const navigate = useNavigate();

  const { sideBarPadding, isUserGracePeriodOver } = useContext(LoginContext);
  const { participantLabel } = useCareLabels();
  const isWorkerBlackPortal = roleAccess([USER_ROLE.Sp_Standard_User]);
  // Mirror invoice preview gating: bulk action + checkboxes only meaningful for
  // batch (case-note based) claims. Participant-based claims expose bulk
  // actions on the list page (one record per participant) instead.
  const isOldBatch = ndisClaimMode === "old";
  const [renderLoading, setRenderLoading] = useState(LOADER_STATUS.NA);
  const [checkboxes, setCheckboxes] = useState([]);
  const [allSelected, setAllSelected] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [status, setStatus] = useState(null);
  const [updatedAction, setUpdatedAction] = useState(null);
  const [fileDownloaderLoader, setFileDownloaderLoader] = useState(false);

  const ndisClaimReviewToMap = useMemo(() => {
    if (caseNotesListForClaim && caseNotesListForClaim.length > 0) {
      return caseNotesListForClaim;
    }
    return [];
  }, [caseNotesListForClaim]);

  const handleCheckboxChange = (e, id) => {
    const filteredList = checkboxes.filter((c) => c !== id);
    if (e) {
      filteredList.push(id);
    }
    setCheckboxes(filteredList);
  };

  const toggleCheckboxes = (val) => {
    setCheckboxes(val ? caseNoteReview.map((t) => t.id) : []);
  };

  useEffect(() => {
    if (
      caseNoteReview &&
      checkboxes &&
      checkboxes.length === caseNoteReview.length &&
      caseNoteReview.length !== 0
    ) {
      setAllSelected(true);
    } else {
      setAllSelected(false);
    }
  }, [checkboxes]);

  useEffect(() => {
    if (!caseNotesListForClaimLoader && renderLoading !== LOADER_STATUS.NA) {
      setRenderLoading(LOADER_STATUS.COMPLATE);
    }
  }, [caseNotesListForClaimLoader]);

  useEffect(() => {
    setCheckboxes([]);
    getCaseNotesReviewRequest({
      id: uuid,
      pt_id:
        selectedClient && selectedClient.uuid ? selectedClient.uuid : "all",
      status: status ? status.value : "all",
    });
  }, [status, selectedClient]);

  useEffect(() => {
    getNdisClaimMode && getNdisClaimMode();
  }, [getNdisClaimMode]);

  useEffect(() => {
    if (!isOldBatch) return;
    if (updatedAction && updatedAction && checkboxes.length > 0) {
      handleChangeAction();
    }
  }, [updatedAction, isOldBatch]);

  // const [clientHoursReport, setClientHoursReport] = useState(false);
  // const [cosHoursReport, setCosHoursReport] = useState(false);

  // useEffect(() => {
  //   if (cosHoursReport) {
  //     const dataToPrint = convertCosDataToPrint(caseNoteReview);
  //     setPrintData(dataToPrint);
  //   }
  // }, [cosHoursReport]);

  // useEffect(() => {
  //   if (clientHoursReport) {
  //     const dataToPrint = convertClientDataToPrint(caseNoteReview);
  //     setPrintData(dataToPrint);
  //   }
  // }, [clientHoursReport]);

  const handleChangeAction = async () => {
    if (isUserGracePeriodOver) return;
    if (
      updatedAction &&
      checkboxes.length > 0 &&
      (updatedAction === "pdf" || updatedAction === "xlsx")
    ) {
      try {
        setFileDownloaderLoader(true);
        const res = await api.changeNDISClaimActionsApi({
          report: updatedAction,
          cos_case_notes_ids: checkboxes,
        });

        if (res && res.report) {
          await FileSaver.saveAs(
            res.report.download_url,
            `NDIS-Claim-${updatedAction === "xlsx" ? "EXCEL" : "PDF"}-File${
              updatedAction === "xlsx" ? ".csv" : ".pdf"
            }`
          );
        }
        setCheckboxes([]);
        setUpdatedAction("");
        setFileDownloaderLoader(false);
      } catch (err) {
        setUpdatedAction("");
        setFileDownloaderLoader(false);
        console.log("err", err);
        toast.error("Something went wrong while downloading!");
      }

      return;
    }
    swal({
      title: "Confirm your action?",
      text: `${getText()}`,
      icon: "",
      buttons: ["No, take me back!", "Yes, go ahead!"],
      className: "",
      cancel: {
        text: "No, take me back!",
        value: null,
        visible: false,
        className: "",
        closeModal: true,
      },
      confirm: {
        text: "Yes, go ahead!",
        value: true,
        visible: true,
        // className: `${
        //   updatedAction === "cancelled" ? "bg-blue-600" "
        // }`,
        closeModal: true,
      },

      dangerMode: updatedAction === "cancelled" ? true : false,
    }).then((willDelete) => {
      if (isUserGracePeriodOver) return;
      if (willDelete) {
        if (checkboxes.length > 0) {
          changeStatus({
            status: updatedAction,
            cos_case_notes_ids: checkboxes,
            navigate,
          });
          setCheckboxes([]);
          setUpdatedAction("");
        }
      } else {
        setCheckboxes([]);
        setUpdatedAction("");
      }
    });
  };

  const getText = () => {
    if (updatedAction === "revert") {
      return "Are you sure you want to Revert these case notes";
    } else if (updatedAction === "cancelled") {
      return "Are you sure you want to cancel these case notes";
    } else if (updatedAction === "extract_generated") {
      return "Are you sure you want to undo cancel these case notes";
    } else if (updatedAction === "provider_paid") {
      return "Are you sure you want to Change the action to  Provider Paid";
    } else if (updatedAction === "xero") {
      return "Are you sure you want to Export the selected claim case note(s) to Xero?";
    }
    return "Are you sure you want to proceed?";
  };

  useEffect(() => {
    if (statusList && statusList) {
      statusList.unshift({ label: "All", value: "all" });
    }
  }, [statusList]);

  useEffect(() => {
    if (selectedClientList && selectedClientList) {
      selectedClientList.unshift({ label: "All", value: "all" });
    }
  }, [selectedClientList]);
  useEffect(() => {
    if (!caseNoteReview && changeStatusSuccess === true) {
      navigate("/cos/ndis-claims");
    }
  }, [caseNoteReview]);

  useEffect(() => {
    if (
      caseNoteReview &&
      caseNoteReview.length === 0 &&
      changeStatusSuccess === true
    ) {
      navigate("/cos/ndis-claims");
    }
  }, [caseNoteReview]);

  useEffect(() => {
    return () => emptyTableData();
  }, []);

  return (
    <>
      <div className='min-h-full min-w-0'>
        <SideBar />
        <div
          className={`${
            sideBarPadding
              ? "lg:pl-[4rem] duration-300"
              : "lg:pl-64 duration-300"
          } flex min-h-screen min-w-0 flex-col`}
        >
          <main className='flex w-full min-w-0 flex-1 flex-col bg-white pb-10'>
            <Header
              title='NDIS Claim Review'
              breadcrumb={
                <Breadcrumb
                  pages={COS_BREADCRUMB(
                    COS_BREADCRUMB_PAGES.CREATED_NDIS_CLAIMS_REVIEW
                  )}
                />
              }
            />
            <div className='w-full min-w-0 bg-white px-3 py-3 sm:px-4'>
              <div className='sticky top-[80px] z-[60] my-3 flex flex-col gap-4 bg-white py-2 sm:flex-row sm:flex-wrap sm:items-end sm:justify-between'>
                <div className='grid min-w-0 w-full grid-cols-1 gap-3 sm:grid-cols-2 lg:flex-1'>
                  <div className='min-w-0'>
                    <label className='block text-start text-sm font-medium text-gray-700 text-start'>
                      {participantLabel}
                    </label>
                    <SelectOption
                      isClearable={true}
                      isDisabled={
                        caseNoteReviewLoading ||
                        changeNDISCaseNotesStatusLoading
                      }
                      cssClass=''
                      name='client'
                      isSearch={false}
                      data={selectedClientList && selectedClientList}
                      handleChange={(e) => {
                        setSelectedClient(e);
                      }}
                      selectedOption={selectedClient}
                    />
                  </div>
                  <div className='min-w-0'>
                    <label className='block text-start text-sm font-medium text-gray-700 text-start'>
                      Status
                    </label>
                    <SelectOption
                      isClearable={true}
                      isDisabled={
                        caseNoteReviewLoading ||
                        changeNDISCaseNotesStatusLoading
                      }
                      cssClass=''
                      name='sp_cos_id'
                      isSearch={false}
                      data={statusList && statusList}
                      handleChange={(e) => {
                        setStatus(e);
                      }}
                      selectedOption={status}
                    />
                  </div>
                </div>
                {isOldBatch && (
                  <div className='relative z-[70] flex w-full min-w-0 shrink-0 justify-end sm:w-auto'>
                    <SelectBox
                      disabled={
                        (checkboxes.length > 0 ? false : true) ||
                        isUserGracePeriodOver
                      }
                      setUpdatedAction={setUpdatedAction}
                      isForCosModule={false}
                      allowXeroExport={!isWorkerBlackPortal}
                    />
                  </div>
                )}
              </div>
              <div className='min-w-0'>
                <div className='flex flex-col'>
                  <div className='-my-2 min-w-0'>
                    <div className='min-w-0 py-2 align-middle'>
                      <div className='max-w-full overflow-x-auto overflow-y-visible rounded-lg border border-gray-200 shadow-sm ring-1 ring-black ring-opacity-5'>
                        <table className='w-full min-w-[1024px] table-fixed divide-y divide-gray-300 capitalize'>
                          <thead className='bg-blue-50 capitalize'>
                            <tr>
                              {isOldBatch && (
                                <th
                                  scope='col'
                                  className='w-[3%] min-w-0 bg-blue-50 px-1 py-4 text-center text-sm font-semibold text-gray-900'
                                >
                                  <div className='flex justify-center'>
                                    <CheckBox
                                      isDisabled={isUserGracePeriodOver}
                                      checked={allSelected}
                                      handleChange={(e) => {
                                        if (isUserGracePeriodOver) {
                                          return;
                                        }
                                        if (
                                          caseNoteReview &&
                                          caseNoteReview.length > 0
                                        ) {
                                          setAllSelected(e);
                                          toggleCheckboxes(e);
                                        }
                                      }}
                                    />
                                  </div>
                                </th>
                              )}

                              <TableHeader
                                isSort={false}
                                label={"Reference"}
                                innerCssClass='truncate'
                                cssClass='w-[6%] min-w-0 px-4 py-4 text-left text-sm font-semibold text-gray-900'
                              />
                              <TableHeader
                                isSort={false}
                                label={"Support Item"}
                                innerCssClass='truncate'
                                cssClass='w-[11%] min-w-0 px-4 py-4 text-left text-sm font-semibold text-gray-900'
                              />
                              <TableHeader
                                isSort={false}
                                label={"Support Item No."}
                                innerCssClass='truncate'
                                cssClass='w-[7%] min-w-0 px-4 py-4 text-left text-sm font-semibold text-gray-900'
                              />
                              <TableHeader
                                isSort={false}
                                label={"Created By"}
                                innerCssClass='truncate'
                                cssClass='w-[6%] min-w-0 px-4 py-4 text-left text-sm font-semibold text-gray-900'
                              />
                              <TableHeader
                                isSort={false}
                                label={"Created Date"}
                                innerCssClass='whitespace-normal break-words leading-tight'
                                cssClass='w-[7%] min-w-[4.5rem] px-4 py-4 text-left text-sm font-semibold text-gray-900 align-top'
                              />
                              <TableHeader
                                isSort={false}
                                label={participantLabel}
                                innerCssClass='truncate'
                                cssClass='w-[10%] min-w-0 px-4 py-4 text-left text-sm font-semibold text-gray-900'
                              />
                              <TableHeader
                                isSort={false}
                                label={"Mgmt Style"}
                                innerCssClass='truncate'
                                cssClass='w-[6%] min-w-0 px-4 py-4 text-left text-sm font-semibold text-gray-900'
                              />
                              <TableHeader
                                isSort={false}
                                label={"Date Delivered"}
                                innerCssClass='truncate'
                                cssClass='w-[11%] min-w-0 px-4 py-4 text-left text-sm font-semibold text-gray-900'
                              />
                              <TableHeader
                                isSort={false}
                                label={"Quantity"}
                                innerCssClass='truncate'
                                cssClass='w-[6%] min-w-0 px-4 py-4 text-left text-sm font-semibold text-gray-900'
                              />
                              <TableHeader
                                isSort={false}
                                label={"Rate"}
                                innerCssClass='truncate'
                                cssClass='w-[6%] min-w-0 px-4 py-4 text-left text-sm font-semibold text-gray-900'
                              />
                              <TableHeader
                                isSort={false}
                                label={"Total Amount"}
                                innerCssClass='truncate'
                                cssClass='w-[7%] min-w-0 px-4 py-4 text-left text-sm font-semibold text-gray-900'
                              />
                              <TableHeader
                                isSort={false}
                                label={"Status"}
                                innerCssClass='truncate'
                                cssClass='w-[7%] min-w-0 px-4 py-4 text-left text-sm font-semibold text-gray-900'
                              />
                              <th className='w-[3%] bg-blue-50 px-4 py-4'>
                                <div className='sr-only'>View</div>
                              </th>
                            </tr>
                          </thead>
                          <tbody className='divide-y divide-gray-200'>
                            {fileDownloaderLoader ||
                            caseNoteReviewLoading ||
                            changeNDISCaseNotesStatusLoading ? (
                              <tr>
                                <td
                                  colSpan={isOldBatch ? 14 : 13}
                                  className='bg-gray-50 py-2'
                                >
                                  <CircularLoader
                                    classes='flex justify-center items-center'
                                    classloader='loader-l'
                                  />
                                </td>
                              </tr>
                            ) : caseNoteReview && caseNoteReview.length > 0 ? (
                              caseNoteReview.map((item, index) => (
                                <NdisClaimNewTableItem
                                  isUserGracePeriodOver={isUserGracePeriodOver}
                                  checkboxes={checkboxes}
                                  handleCheckboxChange={(e) =>
                                    handleCheckboxChange(e, item.id)
                                  }
                                  item={item}
                                  key={index}
                                  rowIndex={index}
                                  showRowCheckbox={isOldBatch}
                                />
                              ))
                            ) : (
                              (!caseNoteReview ||
                                caseNoteReview.length === 0) && (
                                <tr>
                                  <td
                                    colSpan={isOldBatch ? 14 : 13}
                                    className='py-6 text-center text-red-600'
                                  >
                                    No Data Found !
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
      {openModal && (
        <NdisClaimNewModal
          selectedNdisClaims={
            checkboxes &&
            checkboxes.length > 0 &&
            ndisClaimReviewToMap &&
            ndisClaimReviewToMap.length > 0
              ? ndisClaimReviewToMap.filter(
                  (x) => checkboxes.indexOf(x.id) !== -1
                )
              : []
          }
          openModel={openModal}
          handleClose={() => setOpenModal(false)}
        />
      )}
    </>
  );
};

export default NdisClaimReview;
